import React from 'react';
import classNames from 'classnames';

import { useFormControlState } from '../useFormControlState/useFormControlState';

import { useTranslations } from 'shared/hooks';
import { StyledFormHelperText, useStyles } from './FormHelperText.styles';

export const FormHelperText: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const styles = useStyles();
  const { message } = useTranslations(children);
  const { success, hiddenError } = useFormControlState();

  if (hiddenError) {
    return null;
  }

  const formHelperTextClassNames = classNames({
    [styles.success]: success,
  });

  return (
    // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
    <StyledFormHelperText className={formHelperTextClassNames}>{message}</StyledFormHelperText>
  );
};
